class YoutubeFacade extends HTMLElement {
  #trigger;

  connectedCallback() {
    this.#trigger = this.querySelector('.pvc-video-trigger');
    this.#trigger?.addEventListener('click', this.#handleLoad, { once: true });
  }

  disconnectedCallback() {
    this.#trigger?.removeEventListener('click', this.#handleLoad);
  }

  #handleLoad = () => {
    const videoId = this.dataset.videoId;
    const title = this.dataset.videoTitle || 'Video';

    const iframe = document.createElement('iframe');
    iframe.setAttribute('width', '560');
    iframe.setAttribute('height', '315');
    iframe.setAttribute('src', `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`);
    iframe.setAttribute('title', title);
    iframe.setAttribute('frameborder', '0');
    iframe.setAttribute(
      'allow',
      'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
    );
    iframe.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
    iframe.setAttribute('allowfullscreen', '');
    iframe.classList.add('pvc-video-iframe');

    this.replaceChildren(iframe);
    iframe.focus();
  };
}

if (!customElements.get('youtube-facade')) {
  customElements.define('youtube-facade', YoutubeFacade);
}